import React from "react";
import {
  AppstoreIcon,
  CogIcon,
  HomeIcon,
  ListIcon,
  SMSIcon,
  TestDocumentIcon,
  TransferIcon,
} from "../../styles/icons";
import { Accordion } from "@chakra-ui/react";
import {
  DesktopMenuItem,
  DesktopSubMenuItem,
  MobileMenuItem,
  MobileSubMenuItem,
} from "./HomeMenu";

export const DataApiMenu = ({ isDesktop }: { isDesktop: boolean }) => {
  const MenuItem = isDesktop ? DesktopMenuItem : MobileMenuItem;
  const SubMenuItem = isDesktop ? DesktopSubMenuItem : MobileSubMenuItem;

  return (
    <Accordion allowToggle width="100%">
      <MenuItem target="/" icon={<HomeIcon boxSize="20px" />} title="Home" />

      <MenuItem
        target="/data-api/sysadmin/environment"
        icon={<ListIcon boxSize="20px" />}
        title="Environment"
      >
        <SubMenuItem
          target="/data-api/sysadmin/environment/outbound-ip-details"
          icon={<TransferIcon boxSize="20px" />}
          title="Outbound Ip Details"
        />
      </MenuItem>

      <MenuItem
        target="/data-api/sysadmin/configuration"
        icon={<CogIcon boxSize="20px" />}
        title="Configuration"
      />
      <MenuItem
        target="/data-api/sysadmin/apple-pass-signing-certificates"
        icon={<AppstoreIcon boxSize="20px" />}
        title="APSC"
      >
        <SubMenuItem
          target="/data-api/sysadmin/apple-pass-signing-certificates/test-pkcs12-certificate"
          icon={<TestDocumentIcon boxSize="20px" />}
          title="Testing Certificate"
        />
      </MenuItem>

      <MenuItem
        target="/data-api/sysadmin/twilio-configuration/DataAPI"
        icon={<SMSIcon boxSize="20px" />}
        title="Twilio Configuration"
      />
    </Accordion>
  );
};
